import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { ServiceConnectionClient, ServiceConnectionMetadataModel } from '../../../api/api';
import useApiClient from '../../../common/hooks/useApiClient';

export default function useApiServiceConnectionMetadata(): UseQueryResult<ServiceConnectionMetadataModel[], Error> {
	const client = useApiClient(ServiceConnectionClient);
	const metadata = useQuery({
		queryKey: ['serviceConnectionMetadata'],
		queryFn: () => client.getMetadata(),
	});
	return metadata;
}
